import useOnSurfaceChange from 'routes/surface/hooks/use-on-surface-change';
import { notEmpty } from 'utils';
import { useCanvasStageOperations } from 'state/canvas/stage';
import useMiniMapOperations from 'components/canvas/components/mini-map/hooks/mini-map-operations';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';

export default function useSetCanvasInitialPosition(surface: string) {
  const { getCanvasStage, updateCanvasStage } = useCanvasStageOperations(
    surface,
  );

  const fetchSurfaceNodesFromCache = useFetchSurfaceNodesFromCache(surface);

  const nodes = fetchSurfaceNodesFromCache();

  const { translateToCanvasPosition } = useMiniMapOperations(surface);

  useOnSurfaceChange(() => {
    const stage = getCanvasStage();

    if (stage.x === 0 && stage.y === 0 && notEmpty(nodes)) {
      const position = translateToCanvasPosition({
        x: findMostLeftPoint() - window.innerWidth / 2,
        y: findHighestPoint() - window.innerHeight / 2,
      });

      updateCanvasStage(position);
    }
  });

  function findMostLeftPoint() {
    return Math.min(...nodes.map(({ position }) => position.x));
  }

  function findHighestPoint() {
    return Math.min(...nodes.map(({ position }) => position.y));
  }
}
